module.exports = __webpack_public_path__ + "img/ema.70fa4b4f.jpg";